export default defineNuxtRouteMiddleware((to) => {
  if (import.meta.client) {
    const authStore = useAuthStore();
    const { isUnSave } = storeToRefs(authStore);

    if (isUnSave.value) {
      const { $alert } = useNuxtApp();
      if ($alert) {
        $alert.show({
          title: "คุณต้องการออกจากหน้านี้ใช่ไหม?",
          description: "เมื่อออกจากหน้านี้แล้ว ข้อมูลจะไม่ถูกบันทึก",
          actions: [
            {
              label: "อยู่หน้านี้ต่อ",
              variant: "outline",
              onClick: () => {
                $alert.hide();
              },
            },
            {
              label: "ออกจากหน้านี้",
              onClick: () => {
                isUnSave.value = false;
                $alert.hide();
                navigateTo(to, { replace: true });
              },
            },
          ],
        });
      } else {
        isUnSave.value = false;
        navigateTo(to, { replace: true });
        return;
      }

      // Stop navigation/redirect
      return false;
    }

    isUnSave.value = false;
  }
});
